export enum ProductType {
  None = 'None',
  SoftCover = 'Softcover',
  HardCover = 'Hardcover',
  Ebook = 'EBook',
  LargePrint = 'LargePrint',
}
